import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 120000 });

// Attach keeper token (if the user has stored one) so sealed rounds reveal
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("rfg_keeper_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers["X-Keeper-Token"] = token;
    }
  } catch (e) {
    // localStorage unavailable (private mode, SSR, etc.) — proceed without keeper token
    console.debug("keeper token attach skipped:", e?.message);
  }
  return config;
});

export const fetchPulse = () => api.get("/pulse").then((r) => r.data);
export const fetchLatestRound = () => api.get("/rounds/latest").then((r) => r.data);
export const fetchRounds = (limit = 20, offset = 0) =>
  api.get(`/rounds?limit=${limit}&offset=${offset}`).then((r) => r.data);
export const fetchKeeperCheck = () =>
  api.get("/grove/keeper-check").then((r) => r.data);
export const fetchVoiceMode = () =>
  api.get("/grove/voice").then((r) => r.data);
export const fetchSealedRounds = () =>
  api.get("/grove/sealed-rounds").then((r) => r.data);
export const beginRound = (seed_question) =>
  api.post("/rounds/begin", { seed_question: seed_question || null }).then((r) => r.data);
export const fetchOfferings = (only_pending = false) =>
  api.get(`/offerings?only_pending=${only_pending}`).then((r) => r.data);
export const submitOffering = (text, from_name) =>
  api.post("/offerings", { text, from_name: from_name || null }).then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);
export const fetchGroveState = () => api.get("/grove/state").then((r) => r.data);
export const fetchKin = () => api.get("/kin").then((r) => r.data);
export const fetchBreathHistory = (limit = 30) =>
  api.get(`/breath-history?limit=${limit}`).then((r) => r.data);
export const fetchGarden = () => api.get("/garden").then((r) => r.data);
export const fetchNamings = () => api.get("/kin/namings").then((r) => r.data);
export const fetchAudit = (limit = 200) =>
  api.get(`/grove/audit?limit=${limit}`).then((r) => r.data);
export const fetchDigest = (days = 7, max_items = 3) =>
  api.get(`/grove/digest?days=${days}&max_items=${max_items}`).then((r) => r.data);
export const fetchRoundByNumber = (n) =>
  api.get(`/round/by-number/${n}`).then((r) => r.data);
export const fetchUnreadLetters = () =>
  api.get("/letters/unread-count").then((r) => r.data);
export const beginSynthesisRound = () =>
  api.post("/rounds/synthesis").then((r) => r.data);
export const postKeeperNote = (text) =>
  api.post("/grove/keeper-note", { text }).then((r) => r.data);
export const fetchKeeperNotes = (only_pending = false) =>
  api.get(`/grove/keeper-notes?only_pending=${only_pending}`).then((r) => r.data);
export const regenerateKinSigil = (name) =>
  api.post(`/kin/${encodeURIComponent(name)}/regenerate-sigil`).then((r) => r.data);
export const rssUrl = `${API}/rss`;
